import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Layout, LayoutProps } from 'react-admin';
import {
  applyExactTotal,
  matchesDeferredListQuery,
  registerDeferredListTotal,
} from '@/providers/turn/deferredListTotal';
import Menu from '../Menu';
import { Wrapper } from './styled';

const DeferredListTotal = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    registerDeferredListTotal((resource, payload, total) => {
      queryClient.setQueriesData(
        { predicate: (query) => matchesDeferredListQuery(query.queryKey, resource, payload) },
        (current) => applyExactTotal(current, total)
      );
    });
    return () => registerDeferredListTotal(null);
  }, [queryClient]);

  return null;
};

const DefaultLayout = (props: LayoutProps) => {
  return (
    <Wrapper>
      <DeferredListTotal />
      <Layout menu={Menu} {...props} />
    </Wrapper>
  );
};

export default DefaultLayout;
